import { Injectable } from '@angular/core';
import { CoreService } from '@app/modules/core/services/core.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as AuthActions from '../actions/auth.actions';

@Injectable()
export class AuthEffects {

    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.login),
            switchMap(({ data }) => from(this.coreService.login(data))
                .pipe(
                    map(response => AuthActions.loginSuccess({ response })),
                    catchError(error => of(AuthActions.loginFailure({ error: this.coreService.handleError(error) })))
                )
            )
        )
    );

    signup$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.signup),
            switchMap(({ data }) => from(this.coreService.signup(data))
                .pipe(
                    map(response => AuthActions.signupSuccess({ response })),
                    catchError(error => of(AuthActions.signupFailure({ error: this.coreService.handleError(error) })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private coreService: CoreService
    ) { }
}
